export const toFormattedDateTime = (
  date: string,
  hour: string,
  datePtBR: boolean = false
) => {
  const splitDate = date.split('/');
  const formattedDate = datePtBR
    ? `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`
    : date;

  let formattedHour = hour;

  const splitHour = hour.split(':');
  if (splitHour.length === 2) {
    formattedHour = hour + ':00';
  }

  return `${formattedDate}T${formattedHour}`;
};

export const toInputDate = (date: Date) => {
  let day = date.getDate().toString();
  if (day.length < 2) day = `0${day}`;

  let month = (date.getMonth() + 1).toString();
  if (month.length < 2) month = `0${month}`;

  const year = date.getFullYear().toString();

  return `${year}-${month}-${day}`;
};

export const toInputTime = (date: Date) => {
  let hours = date.getHours().toString();
  if (hours.length < 2) hours = `0${hours}`;

  let minutes = date.getMinutes().toString();
  if (minutes.length < 2) minutes = `0${minutes}`;

  return `${hours}:${minutes}`;
};

export const getMealFlag = (meal: 'No' | 'Half' | 'Full' | 'Repeat') => {
  switch (meal) {
    case 'No':
      return 'Não quis';
    case 'Half':
      return 'Quis metade';
    case 'Full':
      return 'Quis todo';
    case 'Repeat':
      return 'Repetiu';
    default:
      return null;
  }
};

export const getFirstAndSecondName = (name: string) => {
  const nameArray = name.split(' ');

  if (nameArray.length > 1) {
    const firstName = nameArray[0];
    const secondName = nameArray[1];

    return `${firstName} ${secondName}`;
  }

  return name;
}

export const getPeriodName = (period: 'Morning' | 'Afternoon' | 'Night' | 'WholeDay') => {
  switch (period) {
    case 'Morning':
      return 'Manhã';
    case 'Afternoon':
      return 'Tarde';
    case 'Night':
      return 'Noite';
    case 'WholeDay':
      return 'Integral';
    default:
      return null;
  }
}

export const getEmployeeRole = (role: 'Administrator' | 'Teacher') => {
  switch (role) {
    case 'Administrator':
      return 'Administrador';
    case 'Teacher':
      return 'Professor';
    default:
      return null;
  }
}

export const getDiaryMode = (role: 'Preschool' | 'Simple') => {
  switch (role) {
    case 'Preschool':
      return 'Pré-escola';
    case 'Simple':
      return 'Regular';
    default:
      return null;
  }
}

export const getGender = (gender: 'NotInformed' | 'Female' | 'Male') => {
  switch (gender) {
    case 'NotInformed':
      return 'Não informado';
    case 'Female':
      return 'Feminino';
    case 'Male':
      return 'Masculino';
    default:
      return null;
  }
}

export const formatPhoneNumber = (number: string) => {
  const digits = number.replace(/\D/g, '');
  const splitNumber = digits.length === 10
    ? digits.match(/(\d{2})(\d{4})(\d{4})/)
    : digits.match(/(\d{2})(\d{5})(\d{4})/);

  if (!splitNumber) {
    return number;
  }

  return `(${splitNumber[1]})${splitNumber[2]}-${splitNumber[3]}`;
}